import genderRows from "./genderPasteAliases.json";
import nationalityRows from "./nationalityPasteAliases.json";

function normalize(s: string) {
  return s.trim().toLowerCase();
}

function buildNationalityAliasToAlpha2(): Map<string, string> {
  return new Map(
    nationalityRows.flatMap((row) =>
      row.aliases
        .map((a) => a.trim())
        .filter((t) => t.length > 0)
        .map((t): [string, string] => [normalize(t), row.alpha2]),
    ),
  );
}

function buildGenderAliasToValue(): Map<string, string> {
  return new Map(
    genderRows.flatMap((row) =>
      row.aliases
        .map((a) => a.trim())
        .filter((t) => t.length > 0)
        .map((t): [string, string] => [normalize(t), row.gender]),
    ),
  );
}

const nationalityAliasToAlpha2 = buildNationalityAliasToAlpha2();
const genderAliasToValue = buildGenderAliasToValue();

/** Maps pasted nationality text (aliases in nationalityPasteAliases.json) to ISO 3166-1 alpha-2. */
export function normalizeCitizenship(value: string): string | undefined {
  return nationalityAliasToAlpha2.get(normalize(value));
}

/** Maps pasted gender text (aliases in genderPasteAliases.json) to MALE or FEMALE. */
export function normalizeGender(value: string): string | undefined {
  return genderAliasToValue.get(normalize(value));
}
